import React, { useEffect, useRef, useContext } from "react";
import { store } from "../context/store";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { LICENCE_KEY } from "../constants/charts";

// am4core.useTheme(am4themes_animated);
am4core.addLicense(LICENCE_KEY);

export default function TimetableBarChart({
  chartId,
  chartData,
  categoryKey,
  valueKey,
  color,
  width,
  height,
  onClick, //  renamed from props
  additionalSeries,
  additionalSeriesColor,
}) {
  const chart = useRef(null);
  const globalState = useContext(store);
  
  useEffect(() => {
  if (chart.current && chartData) {
    chart.current.data = chartData;
  }
}, [chartData]);

  useEffect(() => {
    if (chartData && chartData.length > 0) {
      loadChart();
    }
    
    
    return () => {
      if (chart.current) {
        chart.current.dispose();
      }
    };
   
    
  }, [chartData, valueKey]);

  const loadChart = () => {
    let x = am4core.create(chartId, am4charts.XYChart);
    chart.current = x;

    x.tooltip.label.fontSize = 8;
    x.paddingRight = 20;
    x.stroke = "white";
    x.strokeOpacity = 0;
    x.fontSize = 8;
    x.fill = "white";
    x.strokeAlpha = 0;

    // Y Axis = categories (horizontal bars)
    let categoryAxis = x.yAxes.push(new am4charts.CategoryAxis());
    categoryAxis.renderer.inversed = true;
    categoryAxis.dataFields.category = categoryKey;
    categoryAxis.renderer.minGridDistance = 15;
    categoryAxis.strokeWidth = 0;
    categoryAxis.renderer.grid.template.strokeOpacity = 0;
    categoryAxis.renderer.labels.template.fontSize = 9;
    categoryAxis.renderer.labels.template.fill = "black";
    categoryAxis.renderer.labels.template.horizontalCenter = "right";
    categoryAxis.renderer.axisFills.template.disabled = false;
		categoryAxis.renderer.axisFills.template.fillOpacity = 0.1;
		categoryAxis.renderer.axisFills.template.fill = "grey";
		categoryAxis.renderer.axisFills.template.strokeOpacity = 0;

    // X Axis = values
    let valueAxis = x.xAxes.push(new am4charts.ValueAxis());
    valueAxis.strokeWidth = 0;
    valueAxis.renderer.labels.template.fill = "black";
    valueAxis.renderer.labels.template.fontSize = 9;
    valueAxis.renderer.grid.template.strokeOpacity = 0;

    // Series
    let series = x.series.push(new am4charts.ColumnSeries());
    series.columns.template.tooltipText = "{categoryY}: {valueX.value}";
    series.dataFields.categoryY = categoryKey;
    series.dataFields.valueX = valueKey;
    series.columns.template.width = 20;
    series.strokeWidth = 0;
    series.columns.template.column.cornerRadius(5, 5, 5, 5);
    series.columns.template.fillOpacity = 0.8;

    // Color adapter
    if (color) {
      series.columns.template.adapter.add("fill", function (fill, target) {
        return color;
      });
    }

    //  Add bar click handler
    series.columns.template.events.on("hit", function (ev) {
      const dataItem = ev.target.dataItem.dataContext;
      if (onClick && dataItem) {
        const bandLabel = dataItem[categoryKey];
        console.log("Bar clicked:", bandLabel);
        onClick(bandLabel);
      }
    });

    // Optional: additional overlay series
    if (additionalSeries) {
      let s1 = x.series.push(new am4charts.ColumnSeries());
      s1.columns.template.tooltipText = "{categoryY}: {valueX.value}";
      s1.dataFields.categoryY = categoryKey;
      s1.dataFields.valueX = additionalSeries;
      s1.strokeWidth = 0;
      s1.columns.template.width = am4core.percent(50);
      s1.columns.template.adapter.add("fill", function () {
        return additionalSeriesColor || "#999";
      });
    }

    // Formatting
    x.numberFormatter.numberFormat = "#.00a";
    x.numberFormatter.bigNumberPrefixes = [
      { number: 1e3, suffix: "K" },
      { number: 1e6, suffix: "M" },
      { number: 1e9, suffix: "Bn" },
    ];

    // Set data
    x.data = chartData;
    x.dataSorted = false;
    // Smooth fade-in animation on data update
		x.events.on("datavalidated", function () {
		  series.columns.each(function (column) {
		    column.defaultState.transitionDuration = 600;
		    column.show();
		  });
		});
  };

  return <div id={chartId} style={{ width: width, height: height }}></div>;
}
